import React from 'react';
import * as AppStore from "../../redux/app";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";

const SliderItem = ({item}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const saveIdFn = (section) => {
        if (section === 'hi_jet') {
            dispatch(AppStore.actions.setHomeState(false))
            navigate('/');
        }
    }

    if (item?.type === 'app_section') {
        return (
            <button type="button" key={Math.random().toString()} className="pointer center home-sliderBtn" onClick={() => saveIdFn(item?.url)}>
                <img alt="Jace" src={item?.img} className="home-sliderImage" />
            </button>
        );
    }

    return (
        <a href={item.url} target="_blank" rel="noopener noreferrer" className="home-slideContainer" key={Math.random().toString()}>
            <img alt="Jace" src={item?.img} className="home-sliderImage" />
        </a>
    )
}

export default SliderItem;
